import React from "react";
import { NavDropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const HeaderMenuItems = ({ menuItems }) => {
  const generateMenuItems = (items) => {
    return items.map((item, index) => {
      return (
        <div key={index} className="menu-items">
          {item.haschild && item.items && item.items.length > 0 ? (
            <NavDropdown title={item.name} id="navbarScrollingDropdown">
              {generateSubMenuItems(item.items)}
            </NavDropdown>
          ) : (
            <NavLink
              key={index}
              to={item.link}
              className={({ isActive }) => `${isActive && "nav-active"}`}
            >
              {item.name}
            </NavLink>
          )}
        </div>
      );
    });
  };

  const generateSubMenuItems = (items) => {
    return items.map((item, index) => {
      return (
        <div key={index}>
          {item.haschild && item.items && item.items.length > 0 ? (
            <NavDropdown title={item.name} id="navbarScrollingDropdown">
              {generateSubMenuItems(item.items)}
            </NavDropdown>
          ) : (
            <NavDropdown.Item href={!item?.onclick && item.link}>
              {item.name}
            </NavDropdown.Item>
          )}
        </div>
      );
    });
  };

  return generateMenuItems(menuItems);
};

export default HeaderMenuItems;
